import { render } from "./BgContainer.vue?vue&type=template&id=3b5ab8e5&scoped=true"
const script = {}

import "./BgContainer.vue?vue&type=style&index=0&id=3b5ab8e5&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5ab8e5"]])

export default __exports__